import {
  CourierData,
  GetCompanyCouriers,
  GetProductTypes,
  GetTeamsDDL,
  TeamDDLOption,
} from '../../apis/lookup';
import { GetProducts, GetSensors, ProductData } from '../../apis/onboarding';
import {
  GetHomeServiceLevelCouriers,
  GetLocationsType,
  GetSettingsLocations,
  GetSettingsNewCouriers,
  GetTeams,
} from '../../apis/settings';
import { LocationData, LocationTypeData } from '@/apis/types';

export const getProductsTypeDDL = (token: string): Promise<unknown> => {
  return GetProductTypes(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          const res = data.data.data.length > 0 ? data.data.data : [];
          if (res.length > 0) {
            return res;
          }
        } else {
          return [];
        }
      }
      return [];
    })
    .catch((): unknown[] => {
      return [];
    });
};

export const getSensorsDDL = (token: string): Promise<unknown> => {
  return GetSensors(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          const resp = data?.data?.data.length > 0 ? data?.data?.data : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
      return [];
    })
    .catch((): unknown[] => {
      return [];
    });
};

export const getCompanyCouriersDDL = (
  token: string
): Promise<CourierData[]> => {
  return GetCompanyCouriers(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          const resp =
            data?.data?.data?.couriers?.length > 0
              ? data?.data?.data?.couriers
              : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
      return [];
    })
    .catch((): CourierData[] => []);
};

export const getSettingsCouriersDDL = (token: string): Promise<unknown> => {
  return GetSettingsNewCouriers(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          const resp =
            data?.data?.data?.couriers?.length > 0
              ? data?.data?.data?.couriers
              : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
      return [];
    })
    .catch((): unknown[] => {
      return [];
    });
};

interface Carrier {
  id: string;
  name: string;
  [key: string]: unknown; // optional extra fields
}

interface Carrier {
  id: string;
  name: string;
}

interface ServiceLevelCourierRes {
  data?: {
    data?: {
      is_success: boolean;
      message: string;
      data?: {
        carriers?: Carrier[];
      };
    };
  };
  message?: string;
}

export const getServiceLevelCouriersDDL = (
  token: string
): Promise<Carrier[]> => {
  return GetHomeServiceLevelCouriers(token)
    .then((res: ServiceLevelCourierRes) => {
      const innerData = res?.data?.data;
      if (innerData?.is_success) {
        return innerData?.data?.carriers ?? [];
      }
      return [];
    })
    .catch((): Carrier[] => []);
};

export const getProductDDL = (token: string): Promise<ProductData[]> => {
  return GetProducts(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          const resp = data?.data?.data.length > 0 ? data?.data?.data : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch((): ProductData[] => []);
};

export const getLocationDDL = (
  token: string,
  dropdown?: boolean
): Promise<Array<LocationData>> => {
  return GetSettingsLocations(token, dropdown)
    .then((res) => {
      if (
        res?.data?.data?.is_success &&
        res?.data?.data?.data?.data?.length > 0
      ) {
        return res.data.data.data?.data;
      }

      return [];
    })
    .catch((): LocationData[] => []);
};
export const getLocationTypeDDL = (
  token: string
): Promise<Array<LocationTypeData>> => {
  return GetLocationsType(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          const resp = data?.data?.data?.length > 0 ? data?.data?.data : [];
          return resp;
        } else {
          return [];
        }
      }
      return [];
    })
    .catch((): LocationTypeData[] => []);
};

export const getTeamsDDL = (token: string): Promise<unknown> => {
  return GetTeams(token)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          const resp = data?.data?.data.length > 0 ? data?.data?.data : [];
          if (resp.length > 0) {
            return resp;
          }
        } else {
          return [];
        }
      }
    })
    .catch(() => {});
};

const FeatureLabelMap: Record<string, string> = {
  SHIPMENT: 'shipment',
  ALERTCUSTOMIZATION: 'alert_customization',
  ALERTTHRESHOLDS: 'alert_thresholds',
  TRANSPORTPROVIDERS: 'transport_providers',
  INVENTORY: 'inventory',
  PRODUCTS: 'products',
  SHIPMENTNOTIFICATION: 'shipment',
  LOCATIONS: 'locations',
  USERS: 'users',
  REPORTSHIPMENTTEAMS: 'shipment',
  BULKSHIPMENT: 'shipment',
  SENSORS: 'sensors',
};

export const getTeamsDDLOFFeature = (
  token: string,
  featureName: string,
  search?: string
): Promise<TeamDDLOption[]> => {
  const featureKey = (featureName || '').replace(/\s+/g, '').toUpperCase();

  const label = FeatureLabelMap[featureKey] || featureName;

  return GetTeamsDDL(token, label, search)
    .then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          const items = data.data.data.length > 0 ? data.data.data : [];
          if (items.length > 0) {
            let arr = items;
            const features = [
              'Locations',
              'Products',
              'Shipment',
              'Alert Customization',
              'Alert Thresholds',
              'Inventory',
            ];
            const shouldFilterDefault =
              featureName && features.includes(featureName);

            if (shouldFilterDefault) {
              arr = items.filter((x) => x.name.toLowerCase() !== 'default');
            }
            return [...arr].sort((a, b) => {
              const aDefault =
                (a.name || '').toLowerCase() === 'default' ? 0 : 1;
              const bDefault =
                (b.name || '').toLowerCase() === 'default' ? 0 : 1;
              if (aDefault !== bDefault) return aDefault - bDefault;
              return (a.name || '').localeCompare(b.name || '', undefined, {
                sensitivity: 'base',
              });
            });
          }
        } else {
          return [];
        }
      }
    })
    .catch((): TeamDDLOption[] => {
      return [];
    });
};
